import React from 'react';
import './modalCloseButton.scss';
export default function ModalCloseButton(props) {
  return /*#__PURE__*/React.createElement("button", Object.assign({
    className: "btFlavorSelector__modalCloseButton",
    type: "button",
    title: "close"
  }, props), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"
  })));
}